/**
 * Service entry on an waiting list appointment
 */
var WaitListAppointmentsServiceView = Backbone.Epoxy.View.extend({
  template: 'account.account-wait-list.waitListAppointmentsService',

  bindings: {
    '.js-waitlist-value--service__addons': 'toggle: hasAddons, text: addonsString',
    '.js-waitlist-value--service__index': 'text: index',
    '.js-waitlist-value--service__photo': "attr:{ src: employeePhoto(photoId, 'small') }",
    '.js-waitlist-value--service__employee': 'text: employeeNameString',
    '.js-waitlist-value--service__name': 'text: serviceName',
    '.js-waitlist-value--service__prices': 'toggle: showPrice, text: priceString',
    '.js-waitlist-toggle--service__addons': 'toggle: hasAddons',
    '.js-waitlist-toggle--service__prices': 'toggle: showPrice',
    '.js-waitlist-toggle--service__client': 'text: fullName',
  },

  initialize: function() {
    this.hasRendered = false;
    this.render();
  },

  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {
    this.applyBindings();
  },

  cleanup: function() {
    this.removeBindings();
  }
});

module.exports = WaitListAppointmentsServiceView;